'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _userHelper = require('../../../common/users/userHelper');

var _LinkButton = require('../../components/buttons/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userButtonHandler = {
    handleClick: function handleClick(_ref) {
        var user = _ref.user,
            addUser = _ref.addUser;
        return function (event) {
            return addUser({ userEmail: (0, _userHelper.getEmail)(user) });
        };
    }
};

var TeamSuggestionButton = function TeamSuggestionButton(_ref2) {
    var user = _ref2.user,
        handleClick = _ref2.handleClick;
    return _react2.default.createElement(
        _LinkButton2.default,
        { onClickFn: handleClick },
        (0, _userHelper.getName)(user)
    );
};

TeamSuggestionButton.propTypes = {
    user: _propTypes2.default.object,
    handleClick: _propTypes2.default.func
};

exports.default = (0, _recompose.withHandlers)(userButtonHandler)(TeamSuggestionButton);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/teamSuggestions/TeamSuggestionButton.js
// module id = 756
// module chunks = 0